import styles from 'component-styles/pages/pricing-page.scss'
import React, { useEffect } from 'react'
import { IPageBehaviorComponentProps } from './PageBehaviors'

export default function PricingPage({ children }: IPageBehaviorComponentProps) {
  const trackVisitedPricingPage = () => {
    window.Intercom('trackEvent', 'visited_pricing_page')
  }
  useEffect(() => {
    window.addEventListener('load', trackVisitedPricingPage)
    return () => window.removeEventListener('load', trackVisitedPricingPage)
  }, [])

  return (
    <>
      {children}
      <style jsx>{styles}</style>
    </>
  )
}
